import { defineComponent, nextTick } from "vue";
import axios from 'axios'

import { store } from '#models/store.js'
import AuthorizationDisclosureFormVue from "#components/AuthorizationDisclosureForm/AuthorizationDisclosureForm.vue";
import PatientInfoFormVue from "#components/PatientInfoForm/PatientInfoForm.vue";
import CancellationPolicyFormVue from "#components/CancellationPolicyForm/CancellationPolicyForm.vue";
import FinancialPolicyFormVue from "#components/FinancialPolicyForm/FinancialPolicyForm.vue";
import { VForm } from "vuetify/components";

export default defineComponent({
    components: {
        'authorization-disclosure-form': AuthorizationDisclosureFormVue,
        'patient-form': PatientInfoFormVue,
        'cancellation-policy-form': CancellationPolicyFormVue,
        'financial-policy-form': FinancialPolicyFormVue
    },
    data() {
        return {
            store,
            error: null,
            loading: false,
            valid: true
        }
    },
    computed: {
        formRef(): VForm {
            return this.$refs.formRef
        }
    },
    methods: {
        async onSubmit() {
            const { valid } = await this.formRef.validate()
            if (!valid) {
                await nextTick()
                const firstErrorElement = document.querySelector(
                    '.v-input--error, .v-select--error, .v-file-input--error, .v-textarea--error'
                ) as HTMLElement | null

                if (firstErrorElement) {
                    firstErrorElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center', // "center" is nicest on mobile & desktop
                    })

                    const input = firstErrorElement.querySelector('input, textarea, select')
                        ; (input as HTMLElement | null)?.focus()
                }
                return;
            }

            await this.submit()
        },
        async submit() {
            let form = store.toJSON();
            this.loading = true;
            try {
                this.error = null;
                let fd = new FormData();
                fd.append('form', JSON.stringify(form));
                if (store.patientForm.medicationListUploadType == 'file' && store.patientForm.medicationListFile)
                    fd.append('file', store.patientForm.medicationListFile);
                let result = await axios.post('/forms/onesubmit', fd)
                if (result?.data?.success == false) {
                    this.error = result.data.error;
                }
                await store.removeBackups();
                window.location.href = '/forms/form_success';
            }
            catch (err) {
                this.error = typeof err == 'string' ? err : err.toString();
            }
            finally {
                this.loading = false;
            }
        }
    }
})
